import { procoreClient } from "./client";
import { parseFlexibleResponse } from "./utils";

type ProcoreCurrentSceneVersionResponse =
    | { data: { id: string } }
    | { data: { scene_version_id: string } }
    | { id: string }
    | { scene_version_id: string }
    | string;

export async function getProcoreCurrentSceneVersionId(params: {
    companyId: number;
    projectId: number;
    sceneId: string;
}): Promise<string> {
    // Use custom parseResponse to handle both JSON and plain text responses
    const raw = await procoreClient<string>(
        `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/bim/scenes/${params.sceneId}/versions/current`,
        {
            method: "GET",
            parseResponse: async (res) => res.text(),
        },
    );

    const parsed = parseFlexibleResponse<ProcoreCurrentSceneVersionResponse>(raw);

    if (typeof parsed === "string") {
        const v = parsed.trim().replace(/^"|"$/g, "");
        if (v) {
            return v;
        }
    }

    if (parsed && typeof parsed === "object") {
        if ("scene_version_id" in parsed && typeof parsed.scene_version_id === "string") {
            return parsed.scene_version_id;
        }
        if ("id" in parsed && typeof parsed.id === "string") {
            return parsed.id;
        }
        if ("data" in parsed && parsed.data && typeof parsed.data === "object") {
            const d = parsed.data as Record<string, unknown>;
            if (typeof d.scene_version_id === "string") {
                return d.scene_version_id;
            }
            if (typeof d.id === "string") {
                return d.id;
            }
        }
    }

    throw new Error("Could not determine current scene_version_id from response");
}
